/**
* Created by lobin on 2020/6/17.
*/
<template>
  <span class="cabinet-status">
    <span v-if="status === '1'">
      <a-badge status="processing" />在线
    </span>
    <span v-if="status === '6'">
      <a-badge status="default" />冻结
    </span>
    <span v-if="status === '9'">
      <a-badge status="error" />故障
    </span>
    <span v-if="status === '2'">
      <a-badge status="warning" />离线
    </span>
  </span>
</template>

<script type="text/babel">
export default {
  props: ['status'],
};
</script>

<style lang="less" rel="stylesheet/less">
</style>
